module.exports = __webpack_public_path__ + "media/upscaler.59f57b42.mp4";